export const Separator = () => (
  <svg width="100%" height="2" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 1H568" stroke="var(--outline)" strokeDasharray="2 2" />
  </svg>
);
